import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Link, withRouter } from 'react-router'
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import classNames from 'classnames';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, Image} from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
//import {buttonStyle, marginTopStyle, centerStyle, descriptionStyle} from '../Common/style';
import InputField from '../Common/inputField';
import { Translate, Localize } from 'react-redux-i18n';


class BinForm extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.binDetail
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);

        if (!this.props.currentBin) this.context.router.push('/warehouses');
        else this.props.fetchBinDetail(this.props.currentBin);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.binDetail });
    }

    editBin(id) {
        this.context.router.push("/binForm");
    }

    renderProducts() {
      let products = this.props.currentBinDetail.Product;
      if(products) {
        return products.map(product => {
          return (
            <Row className="marginTopStyle"><Col sm={ 12 }> { product.Name } </Col></Row>
          )
        })
      }
    }

    renderBinDetail() {
        const { detailError, detailIsLoading, currentBinDetail } = this.props;
        if (detailIsLoading && !detailError) return <Spinner className="marginTopStyle"/>
        else if (detailError) return <div className="alert alert-danger">{JSON.stringify(detailError) }</div>
        else if (currentBinDetail) {
            const { Name, Description, IsAtInbound, IsAtOutbound, WarehouseBin_id } = this.props.currentBinDetail
            return (
                <div>
                    <Row><Col sm={ 12 }><h4><Translate value="bin_name" />{Name || 'Name'}</h4></Col></Row>
                    <Row><Col sm={ 12 }><Translate value="warehouse_bin_id" />: {WarehouseBin_id}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><em className="fa fa-building-o marginRightStyle"/>{<Translate value="description" /> || 'Description'}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><Translate value="is_at_inbound_area" />: {IsAtInbound ? 'yes' : 'no'}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><Translate value="is_at_outbound_area" />: {IsAtOutbound ? 'yes' : 'no'}</Col></Row>
                    <Row className="marginTopStyle"><Col sm={ 12 }><Translate value="products" />: </Col></Row>
                    {this.renderProducts()}
                </div>
            )
        }
    }

    render() {
        return (
            <ContentWrapper>
                <Row><Col sm={ 12 }>
                    <Link to="/zoneDetail"  className="btn btn-green buttonStyle" ><em className="fa fa-mail-reply"/></Link>
                    <div className="pull-right">
                        <button className="btn btn-primary buttonStyle" ><Translate value="edit" /></button>
                    </div>
                </Col></Row>
              <Panel className="marginTopStyle" style={{ height: this.state.tableHeight }} >
                    <Row><Col sm={ 12 }>
                        <Translate value="bin_detail_view" /> | <Translate value="bin" />
                    </Col></Row>
                    <br/>
                    <Row>
                        <Col sm={ 1 } />
                        <Col sm={ 2 }>
                            {this.renderBinDetail() }
                        </Col>
                        <Col sm={ 9 }>
                            <Row>
                                <Col sm={ 11 } smOffset={ 1 }>
                                    <Row>
                                        <Col sm={ 3 }>
                                            <Row>
                                                <Col sm={ 1 }><div className="iconred"/></Col>
                                                <Col sm={ 9 }><Translate value="inbound_area" /></Col>
                                            </Row>
                                        </Col>
                                        <Col sm={ 3 }>
                                            <Row>
                                                <Col sm={ 1 }><div className="iconblue" /></Col>
                                                <Col sm={ 9 }><Translate value="outbound_area" /></Col>
                                            </Row>
                                        </Col>
                                        <Col sm={ 3 }>
                                            <Row>
                                                <Col sm={ 1 }><div className="icongray" /></Col>
                                                <Col sm={ 9 }><Translate value="all_bins" /></Col>
                                            </Row>
                                        </Col>
                                        <Col sm={ 3 }>
                                            <Row>
                                                <Col sm={ 1 }><div className="iconyellow" /></Col>
                                                <Col sm={ 9 }><Translate value="selected_bins" /></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row><Col sm={ 12 }>
                                        <Image src="http://placehold.it/720x420" thumbnail responsive />
                                    </Col></Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Panel>
            </ContentWrapper >
        )
    }
}

export default BinForm



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/binDetail.jsx